var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard_icon",
    transform: "translate(22942 22009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-22942 -22009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M12,22A10,10,0,0,1,9,2.458V4.582A8,8,0,1,0,19.418,15h2.124A10,10,0,0,1,12,22Zm9.95-9H11V2.05c.329-.033.663-.05,1-.05A10,10,0,0,1,22,12C22,12.337,21.983,12.671,21.95,13ZM13,4.062V11h6.938A8,8,0,0,0,13,4.062Z",
    fill: "#575757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.c2a6e0b3ae0dd57bbc2647a4af7f6242.svg";
export { ForwardRef as ReactComponent };